// Stops the page from scrolling under the modal and the mobile menu. The page loses its scrollbar, so it gets the
// same width as padding instead and doesn't shift sideways (scrollbar-gutter would paint a bare strip there).
// Counted: each lockScroll(true) needs its lockScroll(false), so closing the modal doesn't unlock under an open menu
let locks = 0;

export function lockScroll(locked) {
    const body = document.body;
    if (locked) {
        if (locks++ > 0) return;
        const scrollbar = window.innerWidth - document.documentElement.clientWidth;
        body.style.paddingRight = scrollbar ? scrollbar + 'px' : '';
        body.style.overflow = 'hidden';
    } else {
        if (locks === 0 || --locks > 0) return;
        body.style.paddingRight = '';
        body.style.overflow = '';
    }
}
